import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-401eb08b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_page = _resolveComponent("header-page");
  const _component_router_view = _resolveComponent("router-view");
  const _component_tooltip = _resolveComponent("tooltip");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_footer_page = _resolveComponent("footer-page");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_header_page), _createVNode(_component_el_config_provider, {
    locale: $data.locale
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view), _createVNode(_component_tooltip)])]),
    _: 1
  }, 8, ["locale"]), _createVNode(_component_footer_page)]);
}